import { useEffect, useRef, useState } from "react";
import {
  getArrayDocDataByID,
  getDocDataById,
  getLocalStringFromFlutter,
  getRefFromId,
  listenCollection,
  queryCollection,
} from "../models/DataFunctions";
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { EasySwitch } from "../textfields/EasySwitch";
import CheckBoxGrey from "../textfields/CheckBoxGrey";
import { all } from "axios";
import { intToHexColor } from "../models/OrgFunctions";
import updateDocApi from "../api/database/updateDocApi";
import SmallSpinner from "../loading/SmallSpinner";
import deleteDocApi from "../api/database/deleteDocApi";
import Modal1 from "../modals/Modal1";
import AddTask from "../folder_modals/AddTask";
import Icon1 from "../icons/Icon";
import { videos } from "./educationHelpers";
import TabGPT from "../tabs/TabGPT";
import LoomEmbed from "../pages/home/LoomEmbed";
import SearchBarGallerie from "../textfields/SearchBarGallerie";
import TextFieldBorderLess from "../textfields/TextFieldBorderLess";
import TextField2T from "../textfields/TextField2T";

const EducationDisplay = ({
  userData,
  orgData,
  visible,
  prefix,
  handleClickVariant,
  navigateWorkspace,
}) => {
  const [tasks, setTasks] = useState([]);
  const [task_selected, setTaskSelected] = useState(null);
  const unsubscribeRef_todo = useRef(null);
  const unsubscribeRef_done = useRef(null);
  const [users, setUsers] = useState([]);
  const [mine, setMine] = useState(true);
  const [newTaskOpen, setNewTaskOpen] = useState(false);
  const [folder, setFolder] = useState(null);
  const [activeTab, setActiveTab] = useState("Paramètres");
  const tabs = [
    { id: "Paramètres", label: "Paramètres" },
    { id: "Dossiers", label: "Dossiers" },
    { id: "Devis", label: "Devis" },
    { id: "Planning", label: "Planning" },
    { id: "Application mobile", label: "Application mobile" },
    { id: "Intégrations", label: "Intégrations" },
  ];
  const [selectedLoomUrl, setSelectedLoomUrl] = useState(null);
  const img_url =
    "https://i.pinimg.com/736x/ca/b2/e6/cab2e656ff82a9dd849203e6e57c8c3a.jpg";
  const handleFetchData = async () => {};

  const [loadingUsersDone, setLoadingUsersDone] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  // Initial data fetch when component becomes visible

  const handleMarkVideoAsSeen = async (video) => {
    if (!userData?.id) return;
    let seen_videos = userData?.seen_videos || [];

    if (!seen_videos.includes(video.url)) {
      seen_videos.push(video.url);
      await updateDocApi(
        getRefFromId("user", userData.id),
        { seen_videos: seen_videos },
        prefix
      );
    }
  };

  useEffect(() => {
    if (visible && userData?.id) {
      handleFetchData();
    }
  }, [visible, userData?.id, orgData?.id]);

  return (
    <div
      className={`absolute right-4  transition-all duration-300 ease-in-out ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-full pointer-events-none"
      }`}
      style={{
        bottom: "82px",
        height: "80vh",
        maxHeight: "700px",
        zIndex: 200000,
      }}
    >
      <Modal1 isOpen={newTaskOpen} onClose={() => setNewTaskOpen(false)}>
        <AddTask
          folder={folder}
          orgData={orgData}
          userData={userData}
          onClose={() => setNewTaskOpen(false)}
          onUpdate={() => handleFetchData()}
        ></AddTask>
      </Modal1>

      <div
        className="bg-white overflow-auto rounded-2xl p-4 shadow-xl shadow-shadow_10 max-h-full h-full w-c700 mt-4"
        style={{
          boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.2)",
          width: selectedLoomUrl ? "900px" : "700px",
        }}
      >
        <div className="h-fit ">
          <div className="flex flex-row justify-between items-center mb-4">
            <div className="text-h2 font-semibold ">
              Apprendre à utiliser hexagone
            </div>
          </div>
          <div className="rounded-full border border-gray-300 px-4  w-c400">
            <TextField2T
              noborder={true}
              label={"Rechercher une vidéo .."}
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
              onAction={() => {}}
            ></TextField2T>
          </div>
          {!searchValue && (
            <TabGPT
              tabs={tabs}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
            ></TabGPT>
          )}
          {selectedLoomUrl && (
            <>
              <div className=" mt-4">
                <LoomEmbed
                  id={selectedLoomUrl.split("https://www.loom.com/share/")[1]}
                ></LoomEmbed>
                <PrimaryButton
                  className="mt-4"
                  onClick={() => setSelectedLoomUrl(null)}
                >
                  Retour aux vidéos
                </PrimaryButton>
              </div>{" "}
            </>
          )}{" "}
          {!selectedLoomUrl && (
            <>
              <div className="flex flex-wrap gap-4 overflow-y-auto h-full mt-2 p-2">
                {videos
                  .filter((v) =>
                    searchValue
                      ? v.title
                          .toLowerCase()
                          .includes(searchValue.toLowerCase()) ||
                        v.subtitle
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                      : v.tab === activeTab
                  )
                  .map((task, index) => (
                    <div
                      key={index}
                      style={{ width: "285px" }}
                      className={`relative flex flex-col  h-fit  shadow-xl hover:shadow-lg transition-shadow duration-300 bg-white rounded-2xl 
                      `}
                    >
                      <div
                        className="w-full   overflow-hidden"
                        onClick={() => {}}
                      >
                        <img
                          style={{
                            // make it random between 30% and 70%
                            objectPosition:
                              "50% " +
                              (30 + Math.floor(Math.random() * 40)) +
                              "%",
                          }}
                          className="w-full  h-c200  object-cover rounded-xl"
                          src={img_url}
                          title={task.title}
                        ></img>
                      </div>{" "}
                      <div
                        style={{ height: "195px" }}
                        className="p-4 absolute w-full flex flex-col bg-gradient-to-b to-75% from-25% from-black to-transparent  rounded-2xl"
                      >
                        <div className=" text-white text-h2 font-medium mb-2">
                          {task.title}
                        </div>
                        <div className="text-h4 text-gray-200 mb-2 ">
                          {task.subtitle}
                        </div>
                        <div className="flex flex-row gap-2 items-center">
                          <div className="text-h4 text-gray-300 border border-gray-500 px-2 py-0.5 rounded-full w-fit ">
                            {task.duration}
                          </div>
                          {task.tab === "Application mobile" && (
                            <Icon1
                              icon_name="smartphone"
                              size={16}
                              fill="white"
                            ></Icon1>
                          )}
                        </div>

                        <div
                          onClick={() => {
                            handleMarkVideoAsSeen(task);
                            setSelectedLoomUrl(task.url);
                          }}
                          className="mt-auto cursor-pointer hover:scale-105 bg-white transition-all duration-300 rounded-xl flex flex-row items-center w-fit gap-2 px-3 py-2 "
                        >
                          <Icon1
                            icon_name="play"
                            size={18}
                            fill="black"
                          ></Icon1>
                          <div className="text-h3 text-black ">
                            Regarder la vidéo
                          </div>
                        </div>
                        {userData?.seen_videos?.includes(task.url) && (
                          <>
                            <div className="absolute bottom-1 w-c250 h-1 rounded-md bg-orange-400"></div>{" "}
                            <div className="absolute bottom-0.5 right-3 h-2 w-2 rounded-md bg-orange-400"></div>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EducationDisplay;
